import api from "./api";
import TokenService from "./token.service";

const login = (email, password) => {
  return api
    .post("/admin/api/v1/authenticate", JSON.stringify({
      email,
      password
    }))
    .then((response) => {
      
        if (response.data.data.accessToken) {
            TokenService.setUser(response.data.data);
        }

        return response.data.data;
    });
};

const logout = () => {
  TokenService.removeUser();
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const AuthService = {
  login,
  logout,
  getCurrentUser,
};

export default AuthService;